import { defer } from "react-router-dom";
import { resolveLoaderResult } from "@/routes/loaderResult";
import { getUpload } from "../common/service";

export function taxUploadLoader() {
  return defer({
    coreData: resolveLoaderResult(getUpload()),
  });
}
